import {
  Box,
  Chip,
  FormControlLabel,
  InputAdornment,
  Stack,
  Switch,
  Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useState } from "react";
//import SelectPerPage from "../../components/select/paginationSelect";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CommonModel from "../../../components/dialog/Common";
import SearchInput from "../../../components/inputs/searchInput";
import useDebounce from "../../../hooks/use.debounce";
import { getUserDetails } from "../../../utils/common";
import { getAllBrandForDropDown } from "../../brands/action";
import { checkUserCreateCredit, getAllCompanyUserforListing, updateUserStatus } from "../action";
import { resetCompany, updateCompany } from "./../companySlice";
import CreateUserModal from "../../../components/dialog/CreateUserModal";
import searchIcon from "../../../assets/images/icons/searchIcon.svg"
import { styled } from '@mui/material/styles';
import CustomPagination from "../../../utils/CustomPagination";
const CustomSearchInput = styled(SearchInput)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "50px !important",
  },
  "& input": {
    padding: '0px !important', paddingLeft: '0px !important'
  }
});
function TableHeading(props) {
  const { order, orderBy } = props;


  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Name",
      type: "",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: true,
      label: "Email",
      type: "",
    },
    {
      id: "contact_number",
      numeric: false,
      disablePadding: true,
      label: "Phone Number",
      type: "",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
      type: "",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Action",
      type: "",
    },
  ];

  // headCell.type == '' || ([headCell.type].includes(subType)) ?
  return (
    <TableHead className="hideActionSort">
      <TableRow sx={{ background: '#DBECFF !important', height: "50px", "& th": { backgroundColor: "inherit !important" }, }}>
        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell?.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={() => null}
              //onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}



export default function Users() {
  const navigate = useNavigate();
  const states = useSelector((state) => state.app);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [status, setStatus] = useState({ id: 0, status: false, name: "", open: false });
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [editedUser, setEditedUser] = useState({contactPersonName:"",phoneNumber:"",email:"",id:null,photoUrl:"",password:"",confirmPassword:"",companyId:""})
  const dispatch = useDispatch();
  const {
    limit,
    page,
    sort_key,
    totalCount,
    totalPages,
    filters,
    listing,
  } = useSelector((state) => state.companySlice);


  const debouncedSearch = useDebounce(filters.search, 500);



  const handleChangePerPage = (event, value) => {
    dispatch(updateCompany({ limit: event.target.value, page: 0 }));
    dispatch(getAllCompanyUserforListing());
  };


  // useEffect(() => {
  //   socket.on(SOCKET_EVENT.COMPANY_CREATED, (data) => {
  //     dispatch(getAllCompanyUserforListing());
  //   });
  // }, [socket]);






  const handleChange = (value) => {
    dispatch(updateCompany({ page: value - 1 }));
    dispatch(getAllCompanyUserforListing());
  };

  const handleRequestSort = (
    event,
    property
  ) => {
    const isAsc = orderBy === property && order === "asc";

    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    // if (property === "status") return;
    dispatch(
      updateCompany({
        sort_type: isAsc ? "asc" : "desc",
        sort_key: property,
      }),
    );
    dispatch(getAllBrandForDropDown());
  };

  useEffect(() => {
    if (debouncedSearch || filters.search == "")
      dispatch(getAllCompanyUserforListing())
  }, [debouncedSearch]);

  useEffect(() => {
    dispatch(getAllCompanyUserforListing())
    return () => dispatch(resetCompany())
  }, []);

  const handleSearch = (event) => {
    //if (event.target.value)
    dispatch(updateCompany({ filters: { ...filters, search: event.target.value } }));
  };

  const handleSearchClear = () => {
    dispatch(updateCompany({ filters: { ...filters, search: "" } }));
    dispatch(getAllCompanyUserforListing());
  };

  const userDetails = getUserDetails();

  return (
    <>
      <Stack direction={"column"} gap={2}>
        <Stack
          className="mainTitle flex-wrap"
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            minHeight: '42px',
             paddingX: '16px'
          }}
        >
          <Typography className="page-title" variant="h1"> Manage Users</Typography>
          <Stack direction="row" justifyContent="flex-end" gap={2} alignItems="center">
          <CustomSearchInput
                className="inputSearch sContrl p-0"
                value={filters.search}
                placeholder={"Search here..."}
                handleSearch={handleSearch}
                clearSearch={handleSearchClear}
                startAdornment={
                  <InputAdornment style={{ borderRadius: '50px !important' }} className="overIcon" position="start"
                    sx={{
                      maxHeight: 'none',
                      height: '38px',
                      minWidth: '38px',
                      marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                    }}>
                    <img src={searchIcon} height={20} width={20} alt="" srcset="" />
                  </InputAdornment>
                } />
                  <button className="btnPrimary"
            disabled={!states?.permissions?.company?.create}
            onClick={() => {
              dispatch(checkUserCreateCredit(setShowCreateUserModal));
              setEditedUser({contactPersonName:"",phoneNumber:"",email:"",id:null,photoUrl:"",password:"",confirmPassword:"",companyId:""});
            }}
          >
            Create User
          </button>
          </Stack>
        </Stack>

        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
            overflow: 'none',
          }}>


          <TableContainer >
            <Table
              stickyHeader aria-label="sticky table"
            >
              <TableHeading
                // numSelected={selected.length}

                order={order}
                orderBy={sort_key}
                //onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                //rowCount={rows.length}
                numSelected={0}
                onSelectAllClick={function (

                ) {
                  throw new Error("Function not implemented.");
                }}
              //order={"desc"}
              />
              <TableBody>
                {listing && listing?.length ? (
                  listing?.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row?.id}
                        className={"tableRow"}
                        sx={{
                          "&:hover": {
                            backgroundColor: '#F0F7FF !important', "& td": {
                              backgroundColor: "inherit !important"
                            },
                          }, height: '60px'
                        }}
                      >

                        <TableCell component="td" scope="row">
                          {row?.contactPersonName || "N/A"}&emsp;{row.isPrimary == 1 && <Chip label="primary" color="primary" />}

                        </TableCell>
                        <TableCell component="td" scope="row">
                          {row?.email || "N/A"}
                        </TableCell>

                        <TableCell align="left">
                          {row?.phoneNumber || "N/A"}
                        </TableCell>
                        <TableCell align="left">
                           {row.isPrimary != 1 ? <Stack direction="row" alignItems="center" >
                            <span className="editIcon">Inactive</span>
                            <FormControlLabel
                              className="toogleBtn"

                              control={
                                <Switch
                                  checked={row.isActive}
                                  onClick={() => setStatus({ id: row.id, status: !row.isActive, name: row?.contactPersonName, open: true })}
                                  color="success"
                                />
                              }
                              label=""
                            />
                            <span className="editIcon" style={{ position: "relative", right: 16 }}>Active</span>

                          </Stack> : <span>Active (By Default)</span>}
                        </TableCell>

                        <TableCell sx={{ cursor: "pointer" }}>



                          <Stack direction="row" alignItems="center" >

                            <div className="actBtnGrps">
                              <span className="editIcon" onClick={() => {
                                setShowCreateUserModal(true);
                                setEditedUser(row)
                                }}>Edit</span>
                            </div>
                          </Stack>



                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow colSpan={10}>
                    <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                      <Typography
                        color="inherit"
                        variant="subtitle1"
                        alignItems={"center"}
                        component="h3"
                      >
                        No Data found!
                      </Typography>

                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

          </TableContainer>
          <Stack
            sx={{
              background: 'transparent',
              height: '60px',
              borderBottom: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
              count={Math.ceil(totalPages / limit) || 0}
              onChange={handleChange}
              currentPage={page}
              handleChangePerPage={handleChangePerPage}
                              limit={limit}
              defaultPage={1} siblingCount={1} boundaryCount={1} />
          </Stack>
          <CommonModel
            open={status.open}
            handleDialogClose={() => setStatus((prev) => ({ ...prev, open: false }))}
            dialogTitle={""}
            dialogPara={`Do you want to ${!status?.status ? "inactive" : "active"} this user “${status.name}”? `}
            nvYes={"Confirm"}
            nvCancel={"Cancel"}
            yesHandle={() => {
              dispatch(updateUserStatus({ id: status.id, isActive: status.status, roleId: "1" }));
              setStatus({ id: 0, status: false, name: "", open: false });
            }}
          />
        </Box>
      </Stack>
      <CreateUserModal open={showCreateUserModal} setOpen={setShowCreateUserModal} editedUser={editedUser}/>

    </>
  );
}
